module.exports = __webpack_public_path__ + "img/p3.5a1d0306.png";